import { before, capitalize, startCase } from 'lodash';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import SEOTags from '~/components/SEOTags';
import LayoutLaunch from '~/layouts/LayoutLaunch';
import SneakerBrandIntroduction from '~/sections/SneakerBrandIntroduction';
import SneakerProductList from '~/sections/SneakerProductList';
import SneakerUpcoming from '~/sections/SneakerUpcoming';
import { convertSlugToString } from '~/utils/converters';

const BrandList = ({ brand, name }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    const currentYear = new Date().getFullYear();
    const nextYear = new Date().getFullYear() + 1;
    const brandName = name || startCase(convertSlugToString(brand as string));

    return (
        <LayoutLaunch>
            <SEOTags
                metaTitle={`${brandName} Sneaker Release Dates & Launch Calendar ${currentYear} | US Drops`}
                description={`Get the full list of ${currentYear} and ${nextYear} ${brand} sneaker releases. Daily updates on upcoming drops & classic re-releases help sneakerheads stay on top of every launch`}
            />
            <div className="pb-8 flex flex-col justify-start gap-4">
                <SneakerBrandIntroduction
                    brandCode={brand as string}
                    brandName={name as string}
                    key={'SneakerBrandIntroduction'}
                />
                <SneakerUpcoming brandCode={brand as string} />
                <SneakerProductList brandCode={brand as string} />
            </div>
        </LayoutLaunch>
    );
};

export default BrandList;

export async function getServerSideProps({ params, query }: GetServerSidePropsContext) {
    const { brand } = params || {};
    const { name } = query || {};
    const _nameBrand = name ? name.toString() : brand?.toString().toUpperCase();
    return {
        props: {
            brand,
            name: name || ''
        }
    };
}
